import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteAccountApplicationMutation} from '../hooks/useAccountApplicationsQuery';
import {useAccountApplicationsSelection} from "../hooks/useAccountApplicationsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteAccountApplicationMutation = useDeleteAccountApplicationMutation();

    const {
        selection,
        handleClearSelection,
    } = useAccountApplicationsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteAccountApplicationMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
